<script lang="ts">
  import { onMount } from "svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import { Table } from "../../components/Table";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import ProductTypeDropdown from "../../components/Business/ProductTypeDropdown.svelte";
  import {
    initList,
    load,
    initDetail,
    loading,
    records,
    pagination,
    record,
    save,
    onEdit,
    onDelete,
    onPageChange,
    onProductTypeSelected,
  } from "./butcher-transform-items.store";
  import { sectionItemDtoTransformFields } from "../../utils/TableFields/butcher-section-item-dto-transform.fields";
  import RecipeDropdown from "../../components/Business/RecipeDropdown.svelte";

  export let sectionId: number;

  $: isNew = $record != null && $record.oid == 0;
  //$: canSubmit = $record != null && $record.srcQuantity > 0 && !!$record.srcProductTypeId && !!$record.dstProductTypeId && $record.lotNumber != "";
  $: canSubmit = $record != null && $record.srcWeight >= 0 && !!$record.dstProductTypeId && $record.dstWeight >= 0 && !!$record.recipeId;

  async function onSubmit() {
    //let _resp: IApiResponse<ISlaughterItem> = await save();
    await save();
    initDetail();
    load();
  }

  function onCancel() {
    initDetail();
    load();
  }

  onMount(() => initList(sectionId));
</script>

{#if !!sectionId && !!$record}
  <div class="columns" style="height: unset;">
    <div class="column is-12">
      <FormLayout {canSubmit} {isNew} on:submit={onSubmit} on:cancel={onCancel}>
        <div class="columns">
          <!--
          <div class="column is-3">
            <FormField>
              <NumberInput name="Kg ingresso" placeholder="0" required={true} bind:value={$record.srcWeight} />
            </FormField>
          </div>
          -->
          <!--
          <div class="column is-3">
            <FormField>
              <ProductTypeDropdown name="Tipo ingresso" required={true} phaseCode="M" bind:value={$record.srcProductTypeId} />
            </FormField>
          </div>
          -->
          <div class="column is-3">
            <FormField>
              <ProductTypeDropdown
                name="Tipo uscita"
                required={true}
                phaseCode="T"
                bind:value={$record.dstProductTypeId}
                on:select={(v) => onProductTypeSelected(v.detail)}
              />
            </FormField>
          </div>
          <!--
          <div class="column is-3">
            <FormField>
              <Input name="Lotto" placeholder="lotto" required={true} bind:value={$record.lotNumber} />
            </FormField>
          </div>
          -->
          <div class="column is-3">
            <FormField>
              <NumberInput name="Kg uscita" placeholder="0" required={true} bind:value={$record.dstWeight} />
            </FormField>
          </div>
          <div class="column is-3">
            <FormField>
              {#key $record.dstProductTypeId}
                <RecipeDropdown name="Ricetta" productTypeId={$record.dstProductTypeId} required={true} bind:value={$record.recipeId} />
              {/key}
            </FormField>
          </div>
        </div>
      </FormLayout>
    </div>
  </div>

  <Table
    loading={$loading}
    fields={sectionItemDtoTransformFields}
    records={$records}
    pagination={$pagination}
    createEnabled={false}
    editEnabled={true}
    deleteEnabled={true}
    on:edit={(e) => onEdit(e.detail)}
    on:delete={(e) => onDelete(e.detail)}
    on:pageChange={(e) => onPageChange(e.detail)}
  />
{/if}
